import Scroller from '@newswire/scroller';

import {
  fadeOutTitle,
  RemovefadeOutTitle,
  fadeInTitle,
  RemovefadeInTitle,
  FadeStepChartHighlight,
  changeAxisScale,
  createAnimation,
  createStackedAnimation,
  changeClassNamesChart,
} from './scroller-helpers';

import text from '../../../data/text.json'; // Text data

// This is where scroller lives

const scenes = document.querySelectorAll('.scene');

const container = document.querySelector('.scrolly-container');

var offset = 1 / 10;

const scroller = new Scroller({
  container: container,
  scenes: scenes,
  offset: offset,
});

scroller.on('init', () => {
  // console.log('Everything is ready to go!')
});

scroller.on('scene:enter', function (d) {
  d.element.classList.add('is-active');

  if (d.index === 0) {
    RemovefadeOutTitle('chart_title', text['weekly-deaths-chart-headline']);
    FadeStepChartHighlight('all');
    changeClassNamesChart('bars_highlighted', 'all', 'weekly_bar_chart');
  }
  if (d.index === 1) {
    // The spring
    fadeOutTitle('chart_title', text['weekly-deaths-chart-headline']);
    FadeStepChartHighlight('Spring2020Chart');
    changeClassNamesChart(
      'bars_highlighted',
      'Spring2020Chart',
      'weekly_bar_chart'
    );
  }

  if (d.index === 2) {
    // Summer peak
    FadeStepChartHighlight('SummerPeakChart');
    changeClassNamesChart(
      'bars_highlighted',
      'SummerPeakChart',
      'weekly_bar_chart'
    );
  }

  if (d.index === 3) {
    // Winter rebound
    createAnimation('weekly_deaths_reported', 'WinterReboundChart', false);
    // FadeStepChartHighlight('WinterReboundChart');
    changeClassNamesChart(
      'bars_highlighted',
      'WinterReboundChart',
      'weekly_bar_chart'
    );
   
  }
  // Vaccines
  if (d.index === 4) {
    RemovefadeInTitle('chart_title', text['total-deaths-chart-headline']);
    changeAxisScale('weekly_deaths_reported');
    createAnimation('weekly_deaths_reported', 'Spring2021Chart', true);
    changeClassNamesChart(
      'bars_highlighted',
      'Spring2021Chart',
      'weekly_bar_chart'
    );
  }

  if (d.index === 5) {
    fadeInTitle('chart_title', text['total-deaths-chart-headline']);
    fadeInTitle('graphic-footer', text['source_text']);
    changeAxisScale('deaths_nursing_homes');
    // This is to get the initial path out of the way
    createStackedAnimation('deaths_nursing_homes', 'totals_stacked');
    changeClassNamesChart('chart-total', 'part-7', 'stacked_bars');
  }

  if (d.index === 6) {
    RemovefadeInTitle('chart_title', text['total-deaths-chart-headline']);
    fadeInTitle('graphic-footer', text['source_text_percent_chart']);
    fadeInTitle('chart_title', text['percent-deaths-chart-headline']);
    changeAxisScale(100);
    createStackedAnimation(100, 'percent_stacked');
    changeClassNamesChart('chart-percent', 'part-8', 'percent_stacked_bars');
  }
});

scroller.on('container:enter', function (d) {
  // console.log('enter:', d);

  document.querySelector('#year-of-deaths-chart').classList.add('sticky-top');
});

scroller.on('scene:exit', function (d) {
  d.element.classList.remove('is-active');
});

scroller.on('container:exit', function (d) {
  // console.log('exit:', d);
  // document.querySelectorAll('.scene').classList.remove('sticky-top');
});

// starts up the IntersectionObserver
scroller.init();
